"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var pascalCase = function pascalCase(attribute) {
  var field = attribute;
  field = "".concat(field.slice(0, 1).toLowerCase()).concat(field.slice(1, field.lenght));
  return field;
};

var camelCase = function camelCase(attribute) {
  var field = attribute;
  var res = field.match(new RegExp('[A-Z]', 'g'));
  var start = 0;

  if (res) {
    res.forEach(function (found) {
      var ind = field.indexOf(found, start);
      field = "".concat(field.slice(0, ind), " ").concat(field.slice(ind, field.lenght));
      start = ind + 2;
    });
  }

  return field.toLowerCase();
};

var snakeCase = function snakeCase(attribute) {
  var field = attribute;
  var res = field.match(new RegExp('_', 'g'));

  if (res) {
    res.forEach(function () {
      field = field.replace('_', ' ');
    });
  }

  return field.toLowerCase();
};

var formatter = function formatter(attribute) {
  var field = pascalCase(attribute);
  field = camelCase(field);
  field = snakeCase(field);
  return field;
};

var _default = formatter;
exports["default"] = _default;